import React, { useEffect, useState } from "react";
import { Typography, Paper, Box, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
import StoreIcon from "@mui/icons-material/Store";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import Shopheader from "../Shop/Shopheader";

// Format JS date into YYYY-MM-DD string
const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const DashboardCard = ({ title, count, icon, color, link }) => (
  <Link to={link || "#"} style={{ textDecoration: "none" }}>
    <Paper
      elevation={4}
      sx={{
        height: 130,
        borderRadius: 2,
        p: 2,
        backgroundColor: color,
        color: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        transition: "0.3s",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 6,
          opacity: 0.95,
        },
      }}
    >
      <Box>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="h5" fontWeight="bold">
          {count}
        </Typography>
      </Box>
      <Box
        sx={{
          fontSize: 50,
          backgroundColor: "rgba(255,255,255,0.15)",
          borderRadius: 2,
          p: 1,
          height: 70,
          lineHeight: 1,
        }}
      >
        {icon}
      </Box>
    </Paper>
  </Link>
);

const Shop = () => {
  const [counts, setCounts] = useState({
    customers: 0,
    vendors: 0,
    sales: 0,
    purchases: 0,
    todaysIncome: 0,
    todaysExpense: 0,
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const todayStr = formatDate(new Date());

        // Customers (only category == shop)
        const custQuery = query(
          collection(db, "customers"),
          where("category", "==", "shop")
        );
        const custSnap = await getDocs(custQuery);
        const customers = custSnap.size;

        // Vendors
        const vendorQuery = query(
          collection(db, "vendors")
        );
        const vendorSnap = await getDocs(vendorQuery);
        const vendors = vendorSnap.size;

        // Sales
        const salesQuery = query(
          collection(db, "sales"),
          where("category", "==", "shop")
        );
        const salesSnap = await getDocs(salesQuery);
        const sales = salesSnap.size;

        // Purchases
        const purchaseQuery = query(
          collection(db, "purchases")
        );
        const purchaseSnap = await getDocs(purchaseQuery);
        const purchases = purchaseSnap.size;

        // ✅ Today's Income (saleDate == todayStr)
        let todaysIncome = 0;
        const salesTodayQuery = query(
          collection(db, "sales"),
          where("category", "==", "shop"),
          where("SaleDate", "==", todayStr)
        );
        const salesTodaySnap = await getDocs(salesTodayQuery);
        salesTodaySnap.forEach((doc) => {
          todaysIncome += parseFloat(doc.data().grandTotal || 0);
        });

        // ✅ Today's Expense (purchaseDate == todayStr)
        let todaysExpense = 0;
        const purchasesTodayQuery = query(
          collection(db, "purchases"),
          where("purchaseDate", "==", todayStr)
        );
        const purchasesTodaySnap = await getDocs(purchasesTodayQuery);
        purchasesTodaySnap.forEach((doc) => {
          todaysExpense += parseFloat(doc.data().grandTotal || 0);
        });

        setCounts({
          customers,
          vendors,
          sales,
          purchases,
          todaysIncome,
          todaysExpense,
        });
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      }
    };

    fetchCounts();
  }, []);

  return (
    <Box>
      <Shopheader />
      <Typography variant="h5" gutterBottom>
        <b> Dashboard</b>
      </Typography>
      <div className="row">
        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="ग्राहक"
            count={counts.customers}
            icon={<PeopleIcon fontSize="inherit" />}
            color="#1976d2"
            // link="/category/shop/customers/mgmt"
          />
        </Grid>

        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="विक्रेते"
            count={counts.vendors}
            icon={<StoreIcon fontSize="inherit" />}
            color="#6a1b9a"
            // link="/category/shop/vendors/mgmt"
          />
        </Grid>

        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="विक्री"
            count={counts.sales}
            icon={<PointOfSaleIcon fontSize="inherit" />}
            color="#0288d1"
            // link="/category/shop/sales"
          />
        </Grid>

        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="खरेदी"
            count={counts.purchases}
            icon={<ShoppingBagIcon fontSize="inherit" />}
            color="#00796b"
            // link="/category/shop/purchase"
          />
        </Grid>

        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="आजची उत्पन्न"
            count={`₹${counts.todaysIncome.toLocaleString()}`}
            icon={<TrendingUpIcon fontSize="inherit" />}
            color="#2e7d32"
            // link="/category/shop/todays-income"
          />
        </Grid>

        <Grid className="col-sm-3 mt-3">
          <DashboardCard
            title="आजचा खर्च"
            count={`₹${counts.todaysExpense.toLocaleString()}`}
            icon={<TrendingDownIcon fontSize="inherit" />}
            color="#c62828"
            // link="/category/shop/todays-expense"
          />
        </Grid>
      </div>
    </Box>
  );
};

export default Shop;
